export function Logo() {
  return (
    <a href="#about" className="navbar__logo" aria-label="Irina Korotkaya — home">
      IK
    </a>
  );
}
